import React from 'react';
import { StyleSheet, TouchableOpacity, type TouchableOpacityProps, View } from 'react-native';

import { theme } from '@garnish/constants';

import { BodyText } from '../../../../../Text';
import { NavbarGlassView } from '../NavbarGlassView/NavbarGlassView';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingGroupOrderInviteeButton = (props: Props) => {
  const { onPress, shadow, title, ...restProps } = props;

  return (
    <TouchableOpacity
      {...restProps}
      accessibilityRole="link"
      activeOpacity={0.7}
      onPress={onPress}
      style={styles.outerContainer}
    >
      <NavbarGlassView canHover shadow={shadow} style={styles.container}>
        <View style={styles.contentContainer}>
          <BodyText
            maxFontSizeMultiplier={1.2}
            numberOfLines={1}
            sizeMatch={['16']}
            style={styles.title}
          >
            {title}
          </BodyText>
        </View>
      </NavbarGlassView>
    </TouchableOpacity>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flexShrink: 1,
    minWidth: 0,
    maxWidth: 400,
  },
  container: {
    height: 48,
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '100%',
    paddingVertical: theme.spacing['1'],
    paddingHorizontal: theme.spacing['6'],
  },
  contentContainer: {
    flexShrink: 1,
    minWidth: 0,
    maxWidth: '100%',
  },
  title: {
    flexShrink: 1,
    minWidth: 0,
    color: theme.colors.CHARCOAL,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  shadow?: boolean;
  title: string;
} & Pick<TouchableOpacityProps, 'aria-label' | 'onPress'>;
